import React from 'react';
import Video from '../presentational/Video'
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function VidoeContailer(props) {
    const [video, setVideo] = useState(null)
    const [open, setOpen] = useState(false)
    const [code, setCode] = useState('')
    const [paused, setPaused] = useState(true)
    const [codeMessage, setCodeMessage] = useState('')
    const [timestamp, setTimestamp] = useState(null)
    const _onReady = (event) => {
        // access to player in all event handlers via event.target
        setVideo(event.target)
        setPaused(true)
        console.log("paused")
    }
    const _onPause = () => {
        console.log("paused")
        setPaused(true)
    }
    const _onPlay = () => {
        console.log("unpaused")
        setPaused(false)
    }
    const replayVideo = () => {
        setTimestamp(0)
    }
    const restartVideo = () => {
        video.seekTo(0)
    }
    const handleClose = () => {
    }
    useEffect(() => {
        console.log(`Fetching (POST) '/law/api/online-cle/OnlineCLE_Videos/video/${props.vid}'`);
        axios.post(`/law/api/online-cle/OnlineCLE_Videos/video/${props.vid}`, {
            token: props.authToken
        })
            .then(res => {
                if (res.data.Timestamp) {
                    setTimestamp(res.data.Timestamp)
                }
                else {
                    setTimestamp(0)
                }
            })
    }, [props.authToken])
    useEffect(() => {
        if (video !== null) {
            video.seekTo(timestamp)
        }
    }, [video])
    useEffect(() => {
        const checkTimestamp = () => {
            if (video !== undefined) {
                console.log(paused)
                if (!paused) {
                    var data = {
                        VideoId: props.vid,
                        Seconds: video.getCurrentTime(),
                        UserToken: props.authToken
                    }
                    console.log(`Fetching (POST) '/law/api/online-cle/OnlineCLE_Videos/Codes'`);
                    axios.post(`/law/api/online-cle/OnlineCLE_Videos/Codes`, data)
                        .then(function (response) {
                            if (response.data.Code) {
                                console.log(response.data)
                                setCode(response.data.Code)
                                setCodeMessage(response.data.CodeMessage)
                                setOpen(true)
                            }
                            else {
                                setOpen(false)
                            }
                        })
                }
            }
        }
        const interval = setInterval(() => {
            checkTimestamp()
        }, 10000);
        return () => clearInterval(interval);
    }, [video, paused]);
    if (timestamp === null) {
        return (<div></div>)
    }
    else {
        return (
            <Video timestamp={timestamp} restartVideo={restartVideo} videoId={props.vid} open={open} code={code} codeMessage={codeMessage} video={video} onReady={_onReady} onPause={_onPause} onPlay={_onPlay} handleClose={handleClose}></Video>
        );
    }
}